import React from 'react';
import ReactMapboxGl, { GeoJSONLayer, Layer, Feature, ZoomControl, Source } from "react-mapbox-gl";
import 'mapbox-gl/dist/mapbox-gl.css';
import { colors } from './DataStructure';

const Mapbox = ReactMapboxGl({
  accessToken: "pk.eyJ1IjoiYmFyYm91cmFiaSIsImEiOiJjamcyMnhkdWcwaGNzMndzMTBkNWswcHFnIn0.EnfN2La_76t7f50c2-AHEQ",
  scrollBar: 'true'});

const colorPalette = (techTypes, colors) => {
  const pal = Object.keys(techTypes).reduce((arr, t) => {
    arr.push(techTypes[t])
    arr.push(techTypes[t] in colors ? colors[techTypes[t]] : '#486784')
      return arr
    },
    ['match', ['get', 'tech']]
  );
  pal.push('#eee');
  return pal;
}

// const circlePaint = (techTypes, colors) => {
//   return {
//
//     'circle-radius': [
//       'interpolate', ['linear'], ['zoom'],
//         5, ['+', ['*',["/", ["number", ["get", "capa"],1], 7000], 6], 2.5],
//         20, ['+', ['*',["/", ["number", ["get", "capa"], 2], 7000], 6], 15],
//       ],
//     'circle-color': colorPalette(techTypes, colors),
//   }
// }

const circlePaint = (techTypes, colors) => {
  return {

    'circle-radius': [
      'interpolate', ['linear'], ['zoom'],
        5, ['+', ['*',["/", ["number", ["get", "capa"],1], 4000], 6], 2.5],
        20, ['+', ['*',["/", ["number", ["get", "capa"], 2], 2500], 6], 15],
      ],
    'circle-color': colorPalette(techTypes, colors),
  }
}



const heatmapPaint = {
// Increase the heatmap weight based on frequency and property magnitude
'heatmap-weight': [
'interpolate',
['linear'],
['get', 'capa'],
0,
0,
100000000,
0.1
],
'heatmap-color': [
'interpolate',
['linear'],
['heatmap-density'],
0,
'rgba(33,102,172,0)',

0.4,
'rgba(254,204,92, 0.8)',
0.6,
'rgba(253,141,60, 0.8)',
0.8,
'rgba(240,59,32, 0.8)',
1,
'rgba(189,0,38, 0.8)'
],
// Adjust the heatmap radius by zoom level
'heatmap-radius': [
'interpolate',
['linear'],
['zoom'],
0,
6,
5, 8,
10, 20,
20,
30
],

}


const boundarySourceOptions = {
   'type': 'vector',
   'url': 'mapbox://barbourabi.bnls6wdm'
};

const boundaryLayerPaint = {
    'line-color': 'black',
    'line-opacity': 0.3,
    'line-width': 0.8
}



const initialBounds = [[ -10.5571271, 48.0186281 ], [ 2.0000000, 60.8406010 ]];

const Map = (props) => {
  const {
    projects,
    handleProjectActive,
    techTypes,
    handleMapObject,
    projectActive,
    projectDetails,
    heatmapLayerActive,
    buildingTypeActive,
    boundaryLayerActive,
    width
  } = props;

  const fitBoundsOptions = { padding: ((width > 769) ? {top: 50, bottom: 50, left: 350, right: 50} : {top: 20, bottom: 20, left: 10, right: 10}), speed: 2 };
  const handleCursor = e => { (e.type === 'mouseenter') ? e.target.getCanvas().style.cursor = 'pointer' : e.target.getCanvas().style.cursor = ''; };
  const handleClick = e => handleProjectActive(e.features[0]);
  const handleMapClick = e => handleProjectActive(false);

  return (
    <div className='map'>
      <Mapbox
        // eslint-disable-next-line
        style='mapbox://styles/barbourabi/ckkxxd60t20u817po75e9fa9n'
        pitch={[0]}
        containerStyle={{ height: '100%', width: '100%' }}
        onClick={ () => handleMapClick(false) }
        fitBounds={ initialBounds }
        fitBoundsOptions={ fitBoundsOptions }
        onStyleLoad={ (m) => handleMapObject(m) }
        >
        {(width > 769) && <ZoomControl/>}


          <Layer
          type='heatmap'
          id='heatmap'
          paint={ heatmapPaint }>

          { heatmapLayerActive && projects.features.map((proj) => {
              return (
                <Feature
                  key={ proj.properties.id }
                  coordinates={ proj.geometry ? proj.geometry.coordinates : '' }
                  capa={ proj.properties.capa } />
              )
            })
          }
        </Layer>



      { !heatmapLayerActive && techTypes && techTypes.length > 0 ? 
          <GeoJSONLayer
          id={ 'projects' }
          data={ projects }
          circlePaint={ circlePaint(techTypes, colors) }
          circleOnClick={ e => handleClick(e) }
          circleOnMouseEnter={ e => handleCursor(e) }
          circleOnMouseLeave={ e => handleCursor(e) }/> : ''
      }

        { !heatmapLayerActive && projectActive &&
          <Layer type="symbol" layout={{ "icon-image": "pulsing-dot" }}>
            <Feature coordinates={ projectDetails.geometry.coordinates }/>
          </Layer>
        }

        <Source id="localAuthorityBoundary" tileJsonSource={ boundarySourceOptions } />

        { boundaryLayerActive &&
        <Layer
          type="line"
          id="localAuthorityBoundary"
          sourceId="localAuthorityBoundary"
          sourceLayer="localAuthorities"
          paint={ boundaryLayerPaint }

          onClick={ event => console.log(event.features[0].properties.geo_label) }

          />
        }






      </Mapbox>
      <a href='https://www.barbour-abi.com' target="_blank" rel="noreferrer">
        <div className='barbour-logo-container'>
          <img className='barbour-logo' src={'https://barbourabi-production-platform-web-images.s3.eu-west-1.amazonaws.com/static/barbourabi-logo-new.svg'} alt='Department for Business Energy and Insdustrial Strategy'/>
        </div>
      </a>
    </div>
  )
}

export default Map;
